import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityInviteGroupList, getActivityInviteGroupUserList, deleteActivityInviteGroupUserList, updateActivityInviteGroupUserList, createActivityInviteGroupUserList } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import vueQr from 'vue-qr';

var _this;

export default {
  name: 'InviteGroupUser',
  components: {
    vueQr: vueQr
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getActivityInviteGroupUserList,
      dialogFormVisible: false,
      dialogTitle: '',
      qrcodeDialogVisible: false,
      type: '',
      qrcodeText: '',
      bairunLogo: require('@/assets/bairun-logo.jpg'),
      groupOptions: [],
      multipleSelection: [],
      formData: {
        groupNo: '',
        userName: '',
        mobile: ''
      },
      rules: {
        userName: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var groupOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getActivityInviteGroupList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 2:
              groupOptions = _context.sent;
              _this2.groupOptions = groupOptions.data.list;
              _context.next = 6;
              return _this2.getTableData();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onAdd: function onAdd() {
      this.type = 'create';
      this.dialogFormVisible = true;
      this.dialogTitle = '新增操作';
    },
    onViewQrcode: function onViewQrcode(row) {
      this.qrcodeDialogVisible = true;
      this.dialogTitle = '邀请码【' + row.userName + '】';
      this.qrcodeText = row.qrcode;
    },
    onUpdate: function onUpdate(row) {
      this.type = 'update';
      this.dialogFormVisible = true;
      this.dialogTitle = '变更操作';
      this.formData = JSON.parse(JSON.stringify(row));
    },
    onDelete: function onDelete(row) {
      var _this3 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return deleteActivityInviteGroupUserList({
                  ID: row.ID
                });

              case 2:
                res = _context2.sent;

                if (res.code === 0) {
                  _this3.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this3.tableData.length === 1) {
                    _this3.page--;
                  }

                  _this3.getTableData();
                } // eslint-disable-next-line handle-callback-err


              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function (err) {});
    },
    enterDialog: function enterDialog() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                _context3.t0 = that.type;
                _context3.next = _context3.t0 === 'create' ? 4 : _context3.t0 === 'update' ? 12 : 14;
                break;

              case 4:
                if (!(that.formData.groupNo === '')) {
                  _context3.next = 7;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '请选择邀新小组'
                });

                return _context3.abrupt("return");

              case 7:
                if (!(that.formData.mobile === '')) {
                  _context3.next = 10;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '请输入手机号'
                });

                return _context3.abrupt("return");

              case 10:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    createActivityInviteGroupUserList(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context3.abrupt("break", 15);

              case 12:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    updateActivityInviteGroupUserList(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context3.abrupt("break", 15);

              case 14:
                return _context3.abrupt("break", 15);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.qrcodeDialogVisible = false;
      this.dialogTitle = '';
      this.type = '';
      this.qrcodeText = '';
      this.formData = {
        groupNo: '',
        userName: '',
        mobile: ''
      };
    }
  }
};